import request from '@/libs/https.js'

//栏目
export function GetClassiFicareTree(param) {
    return request({
        url: '/classificare/tree',
        method: 'get',
        params: param
    })
}

//所属分类的文章列表
export function GetContentList(param) {
    return request({
        url: '/Content/GetContentList',
        method: 'get',
        params: param
    })
}

//所属分类的详情内容，例如：公司荣誉
export function GetContentByClassId(param) {
    return request({
        url: '/Content/GetContentByClassId',
        method: 'get',
        params: param
    })
}

//单文章详情
export function GetContentById(param) {
    return request({
        url: '/Content/GetContentById',
        method: 'get',
        params: param
    })
}
//轮播图
export function GetSlideList(param) {
    return request({
        url: '/Slide/GetSlideList',
        method: 'get',
        params: param
    })
}

//当前分类下的子分类
export function GetContentForClass(param) {
    return request({
        url: '/classificare/GetContentForClass',
        method: 'get',
        params: param
    })
}
//当前分类下的子分类
export function AddResume(param) {
    return request({
        url: '/Resume/AddResume',
        method: 'post',
        data: param
    })
}
/* 上传图片 */
export const uploadImage = (param) => {
    return request({
        url: '/upload/UpFiles',
        data: param,
        method: 'post'
    })
}


//搜索
export function GetSearch(param) {
    return request({
        url: '/Content/GetSearch',
        method: 'get',
        params: param
    })
}
//搜索
export function WebIsAshing(params) {
    return request({
        url: '/classificare/WebIsAshing',
        method: 'get',
        params
    })
}
//漂浮
export function classificareFly(params) {
    return request({
        url: '/classificare/Fly',
        method: 'get',
        params
    })
}
//公示公告
export function Contentgongshi(params) {
    return request({
        url: '/Content/gongshi',
        method: 'get',
        params
    })
}

//重大项目
export function ContentZd(params) {
    return request({
        url: '/Content/zhongdaxingmu',
        method: 'get',
        params
    })
}

//党建品牌
export function ContentDj(params) {
    return request({
        url: '/Content/danagjian',
        method: 'get',
        params
    })
}

//友情链接
export function GetlabelList(params) {
    return request({
        url: '/Slide/labels',
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js